(function ($) {
    Drupal.behaviors.form = {
        attach: function (context, settings) {


                $('.webform-submission-form > form').validate({

                   rules: {
                        civilite: {
                            required: true
                        },
                        a_quel_service_souhaitez_vous_vous_adresser_: {
                            required: true
                        }
                    },

                    highlight: function(element) {
                        $(element).closest('.form-group').addClass('error');

                        $(element).closest('.form-select').addClass('error');

                        if (element.type === 'radio') {
                            $(element).parents().addClass('error');
                        }
                    },

                    unhighlight: function(element) {
                        $(element).closest('.form-group').removeClass('error');

                        $(element).closest('.form-select').removeClass('error');

                        if (element.type === 'radio') {
                            $(element).parents().removeClass('error');
                        }
                    },

                    errorPlacement: function(error, element) {
                        return true;
                    },

                    focusInvalid: false,
                    invalidHandler: function(form, validator) {

                        if (!validator.numberOfInvalids())
                            return;

                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).offset().top - 200
                        }, 1200,'easeInOutExpo');

                    }

                });

/*            $('.form-radio').each(function() {
                $(this).rules('add', {
                    required: true,
                });
            });*/


        }


    };


}(jQuery));


